export default __webpack_public_path__ + "static/bh-d496eaf9751b267a33a22363aae2261c.svg";